import { render, staticRenderFns } from "./OrcidUnitAssignment.vue?vue&type=template&id=39c8cc7a&"
import script from "./OrcidUnitAssignment.vue?vue&type=script&lang=js&"
export * from "./OrcidUnitAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/usage/OrcidUnitAssignment.vue
// module id = 1397
// module chunks = 0